const LocationDefault = [
    {
        key: 72,
        text: 'Tây Ninh',
        maHuyen: '706',
        maXa: '25489',
        dXS: 0.00101036464,
        dYS: -0.00179737020
    },
    {
        key: 22,
        text: 'Quảng Ninh',
        maHuyen: '196',
        maXa: '06835',
        dXS: 0.00099314713,
        dYS: -0.0018854168
    },
    {
        key: 12,
        text: 'Lai Châu',
        maHuyen: '105',
        maXa: '03386'
    },
    {
        key: 93,
        text: 'Lai Châu',
        maHuyen: '930',
        maXa: '31327',
        dXS: 0.00101036464,
        dYS: -0.00178737020
    },
    {
        key: 58,
        text: 'Ninh Thuận',
        maHuyen: '584',
        maXa: '22801',
        dXS: 0.00101036464,
        dYS: -0.00178137015
    },
]
export { LocationDefault }